import { RouteConfig } from 'vue-router'
//
// Layouts
import Webparts from '@webparts/Index.vue'
import TestLayoutView from '../views/common/TestLayoutView.vue'
import PortalLayoutView from '../views/common/PortalLayoutView.vue'
import AdminLayoutView from '../views/common/AdminLayoutView.vue'
//
// Views
import TemplateDesignView from '../views/TemplateDesignTestView.vue'
import WebpartManageView from '../views/WebpartManageTestView.vue'
import TempateManageTestView from '../views/TempateManageTestView.vue'
import PersonalDesignTestView from '../views/PersonalDesignTestView.vue'
import HomeTestView from '../views/HomeTestView.vue'
import WebpartSampleView from '../views/WebpartSampleView.vue'
import BetterKolmar from '@webparts/components/webparts/HK/Popup/BetterKolmar.vue'

var children: any[] = []
if (process.env.NODE_ENV === 'development') {
    children = [...children]
}

const routes: RouteConfig[] = [
    {
        path: 'webparts',
        component: Webparts,
        children: [
            {
                path: 'test',
                component: TestLayoutView,
                children: [
                    {
                        path: 'admin',
                        component: AdminLayoutView,
                        children: [
                            {
                                name: 'admin-main',
                                path: 'webpart',
                                component: WebpartManageView,
                            },
                            {
                                path: 'template',
                                component: TempateManageTestView,
                            },
                            {
                                path: 'designer',
                                component: TemplateDesignView,
                            },
                            {
                                name: 'home-personal',
                                path: 'personal-designer',
                                component: PersonalDesignTestView,
                            },
                            {
                                path: '',
                                redirect: 'webpart',
                            },
                        ],
                    },
                    {
                        path: 'portal',
                        component: PortalLayoutView,
                        children: [
                            {
                                name: 'home',
                                path: 'home',
                                component: HomeTestView,
                            },
                            {
                                path: '',
                                redirect: 'home',
                            },
                        ],
                    },
                    {
                        path: '',
                        redirect: 'portal',
                    },
                ],
            },
            {
                path: '',
                redirect: 'test',
            },
            {
                path: 'sample',
                component : WebpartSampleView
            }
        ],
    },
    {
        path: 'betterKolmar',
        component: BetterKolmar
    }
]
export default routes
